<script setup lang="ts">
import Dialog from 'primevue/dialog'

defineProps<{
    visible: boolean
    title?: string
    modal?: boolean
    closable?: boolean
}>()

defineEmits<{
    (e: 'update:visible', v: boolean): void
}>()
</script>

<template>
    <Dialog
        :visible="visible"
        :header="title"
        :modal="modal ?? true"
        :closable="closable ?? true"
        @update:visible="$emit('update:visible', $event)"
    >
        <slot />
        <template v-if="$slots.footer" #footer>
            <slot name="footer" />
        </template>
    </Dialog>
</template>
